import { render, staticRenderFns } from "./BenifitsAdditionalChildWidget.vue?vue&type=template&id=642b9a26&scoped=true"
import script from "./BenifitsAdditionalChildWidget.vue?vue&type=script&lang=js"
export * from "./BenifitsAdditionalChildWidget.vue?vue&type=script&lang=js"
import style0 from "./BenifitsAdditionalChildWidget.vue?vue&type=style&index=0&id=642b9a26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "642b9a26",
  null
  
)

export default component.exports